import { render, staticRenderFns } from "./NodeCountdown.vue?vue&type=template&id=21dea850&scoped=true&"
import script from "./NodeCountdown.vue?vue&type=script&lang=js&"
export * from "./NodeCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dea850",
  null
  
)

export default component.exports